import { __assign } from "tslib";
import React, { useCallback, useContext } from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getCommentBoxId } from '../../helpers';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import CommentBoxWithSuggestions from '../../../CommentBox/presets/CommentBoxWithSuggestions';
import StickyCommentBox from '../../../CommentBox/presets/StickyCommentBox';
import s from './ThreadPostbox.scss';
var ThreadPostbox = function (_a) {
    var commentableItemId = _a.commentableItemId, commentableTypeId = _a.commentableTypeId, position = _a.position, parentComment = _a.parentComment, currentUser = _a.currentUser, canPostComment = _a.canPostComment, onThreadUpdated = _a.onThreadUpdated, onPublishSuccess = _a.onPublishSuccess, streamId = _a.streamId, className = _a.className, isSmall = _a.isSmall, isSticky = _a.isSticky, withCommentSuggestions = _a.withCommentSuggestions;
    var isMobile = useContext(MobileContext);
    var stickyCommentBoxEnabled = useFlag('sticky_commentbox');
    var handleThreadUpdated = useCallback(function (result) {
        onThreadUpdated && onThreadUpdated(streamId, result);
        onPublishSuccess && onPublishSuccess(result);
    }, [onThreadUpdated, streamId, onPublishSuccess]);
    var CommentBoxPreset = CommentBox;
    var commentBoxProps = {
        id: getCommentBoxId(commentableTypeId, commentableItemId, position),
        className: s['commentbox'],
        commentableType: commentableTypeId,
        commentableItemId: commentableItemId,
        replyComment: parentComment,
        user: currentUser,
        onPublishSuccess: handleThreadUpdated,
        canPostComment: !!canPostComment,
        isSmall: isSmall,
    };
    if (withCommentSuggestions) {
        CommentBoxPreset = CommentBoxWithSuggestions;
    }
    return (React.createElement("div", { className: classnames(s['commentbox-wrapper'], position === 'topmost' && s['commentbox-wrapper-topmost'], position === 'bottom' && s['commentbox-wrapper-bottom'], className) }, isSticky && !isMobile && stickyCommentBoxEnabled ? (React.createElement(StickyCommentBox, __assign({ commentBoxPreset: CommentBoxPreset }, commentBoxProps))) : (React.createElement(CommentBoxPreset, __assign({}, commentBoxProps)))));
};
ThreadPostbox.displayName = 'ThreadPostbox';
export default ThreadPostbox;
//# sourceMappingURL=ThreadPostbox.js.map